import { setDependentAnswerPreset, setDirectAnswerPreset } from "../..";
import { GLOBAL_PRESETS } from "../presets";
import { TAnswerFlow } from "../types";
import * as beautyUtils from "../utils";

export const ESSIE_ANSWER_FLOWS: Record<number, TAnswerFlow> = {
  0: setDirectAnswerPreset(
    undefined,
    "Additional Task Status",
    "radio",
    () => "I completed my Additional Task for this category scheduled this week today."
  ),
  1: setDirectAnswerPreset(
    "Essie",
    "What is the total number of pieces of Essie Nail you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].essie.total_stocked()
  ),
  2: setDirectAnswerPreset(
    "Essie",
    "UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Essie Nail category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].essie.oos_before()
  ),
  3: setDependentAnswerPreset(
    "Essie",
    "Essie Nail: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [2],
    beautyUtils.getAfterOOSCount
  ),
  4: setDependentAnswerPreset(
    "Essie",
    "Essie Nail: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [3],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  5: setDependentAnswerPreset(
    "Essie",
    "Select why 0 Items needed a count correction",
    "radio",
    [4],
    beautyUtils.getWhyZeroItemsNeededCountCorrection
  ),
  6: setDependentAnswerPreset(
    "Essie",
    "Confirm 0 out of stock items need a count correction",
    "radio",
    [4],
    (dependencyAnswers) => {
      const numInaccurateCounts = Number.parseInt(dependencyAnswers[0]);
      if (numInaccurateCounts > 0) return null;
      return "No out of stock items needed a count correction";
    }
  ),
  7: setDirectAnswerPreset(
    "Essie",
    "Are there shelf labels missing on the essie POG",
    "radio",
    () => "No shelf labels are missing from the POG"
  ),
  8: setDependentAnswerPreset(
    "Essie Count Corrections",
    "Did a Team Lead assist you during your service to correct any essie counts for out of stock items in the Inventory Audit",
    "radio",
    [4],
    beautyUtils.getDidATeamMemberAssistYouWithUpdatingOnHands
  ),
  9: setDependentAnswerPreset(
    "Essie Count Corrections",
    "Essie Nail: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [4],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
  10: setDirectAnswerPreset(
    undefined,
    "Did you clean the fixtures and any product needing cleaning on the Maybelline POG & essie POG",
    "radio",
    () => "Yes- all sections on the MNY & essie POG are clean"
  ),
  11: setDirectAnswerPreset(
    undefined,
    "Did you have time to finish all Maybelline Eye, Face, Lip and Essie objectives today",
    "radio",
    () => "Yes"
  ),
};
